<template>
  <div>
    <Endereco @endereco-informado="receberEmitEndereco" v-model:endereco="this.destIntermediarioEditado.endereco"
      ref="enderecoComponent" />

    <br />
    <label for="dataPrevChegada" class="required">Data Prev. Chegada:</label>
    <input type="date" id="dataPrevChegada" :min="this.dataMinima" v-model="destIntermediarioEditado.dataPrevisaoChegada">

    <br />
    <label for="horaPrevChegada" class="required">Hora Prev. Chegada:</label>
    <input type="time" id="horaPrevChegada" v-model="destIntermediarioEditado.horaPrevisaoChegada" />

    <br />
    <label for="dataPrevPartida" class="required">Data Prev. Partida:</label>
    <input type="date" id="dataPrevPartida" :min="this.dataMinima" v-model="destIntermediarioEditado.dataPrevisaoPartida">

    <br />
    <label for="horaPrevPartida" class="required">Hora Prev. Partida:</label>
    <input type="time" id="horaPrevPartida" v-model="destIntermediarioEditado.horaPrevisaoPartida" />

    <span v-if="exibirLocalHospedagem">
      <br />
      <label for="localHospedagem" :class="{ required: obrigatorioLocalHospedagem }">Local de Hospedagem:</label>
      <input type="text" class="estilo60" id="localHospedagem" v-model="destIntermediarioEditado.localHospedagem" />
    </span>

    <br />
    <button @click="emitirDestinoIntermediario">Adicionar</button>
    <br /><br />
  </div>
</template>
  
<script>

import Endereco from '@/components/Endereco.vue';

export default {
  name: 'DestinoIntermediario',
  emits: ['destIntermediario-informado'],
  props: {
    destIntermediario: Object,
    dataMinima: Date,
    exibirLocalHospedagem: Boolean,
    obrigatorioLocalHospedagem: Boolean
  },

  components: {
    Endereco
  },

  data() {
    return {
      destIntermediarioEditado: { ...this.destIntermediario },
    };
  },

  methods: {

    receberEmitEndereco(e) {
      this.destIntermediarioEditado.endereco = e;
    },

    emitirDestinoIntermediario() {
      this.$emit('destIntermediario-informado', this.destIntermediarioEditado);

      // this.resetForm();
      // this.$refs.enderecoComponent.resetForm();
    },

    resetForm() {
      this.destIntermediarioEditado = {
        endereco: null,
        dataPrevisaoChegada: '',
        horaPrevisaoChegada: '',
        dataPrevisaoPartida: '',
        horaPrevisaoPartida: '',
        localHospedagem: ''
      };
    }
  },

  mounted() {
    // IMPORTANTE: Inicializar destIntermediarioEditado com os dados do prop destIntermediario
    this.destIntermediarioEditado = { ...this.destIntermediario };
  },

  watch: {
    destIntermediario: {
      handler(newValue) {
        this.destIntermediarioEditado = { ...newValue };
      },
      deep: true // IMPORTANTE: vê mudanças nas propriedades
    },

  },
};

</script>
  
<style src="../css/transporte.css"></style>